module.exports = __webpack_public_path__ + "static/img/jlyq.f9b23913.svg";